
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.858 5.995l-1.1.444-1.102-.435C13.584 5.58 12.84 4.56 12.84 3.38c0-1.551 1.29-2.83 2.906-2.83 1.617 0 2.907 1.279 2.907 2.83 0 1.173-.735 2.187-1.794 2.615zm-2.302 1.06l1.205-.227 1.205.218c2.408.435 4.182 2.143 4.454 4.171-1.34.741-3.35 1.233-5.634 1.233-.793 0-1.555-.06-2.27-.17A5.825 5.825 0 0011.81 8.33a6.01 6.01 0 012.745-1.273zM9.397 16.008L8 16.538l-1.397-.53C5.136 15.45 4.1 14.046 4.1 12.407 4.1 10.282 5.841 8.55 8 8.55s3.9 1.732 3.9 3.857a3.86 3.86 0 01-2.503 3.6zm-2.893 1.055L8 16.8l1.496.264c3.219.568 5.617 2.906 5.928 5.705C13.67 23.782 11.013 24.45 8 24.45c-3.013 0-5.67-.668-7.424-1.682.311-2.8 2.709-5.137 5.928-5.705z","stroke":"#fff","stroke-width":"1.1"}})])
          )
        }
      }
    